import { ProgressBar } from './ProgressBar';
import { ProgressPercentage } from './ProgressPercentage';
import { type EasingOptions } from 'animejs';
import { font } from '@services/MarppleShop/shared/typography';
import { ProgressAnimationController } from './ProgressAnimationController.ts';
import { isClient } from '../../state-store/utils/env';

export interface ProgressProps {
  start: number;
  end: number;
  easing?: EasingOptions;
  duration?: number;
  klass?: string;
  font?: ReturnType<typeof font>;
  auto?: boolean;
}

export const createProgressParts = (props: ProgressProps) => {
  const bar = new ProgressBar(props);
  const percentage = new ProgressPercentage(props);
  const controller = new ProgressAnimationController(bar, percentage);

  return {
    bar,
    percentage,
    // 렌더링 후 애니메이션을 실행하는 메서드
    startAnimation: () => {
      if (isClient) {
        requestAnimationFrame(() => {
          controller.animate(props);
        });
      }
    },
  };
};
